module.exports = __webpack_public_path__ + "static/media/9DESA14.04ba7edd.jpg";